// Centralised image sources with WebP + JPEG/PNG fallbacks and responsive variants.
import cover400Webp from "@/assets/responsive/cover-400.webp.asset.json";
import cover800Webp from "@/assets/responsive/cover-800.webp.asset.json";
import cover400Jpg from "@/assets/responsive/cover-400.jpg.asset.json";
import cover800Jpg from "@/assets/responsive/cover-800.jpg.asset.json";
import avatar96Jpg from "@/assets/responsive/avatar-96.jpg.asset.json";
import brand160Png from "@/assets/responsive/brand-160.png.asset.json";

// Existing WebP originals (already on the CDN).
const AVATAR_WEBP =
  "/__l5e/assets-v1/ccefc26c-1d9e-4ed8-83ff-2bcc6640859c/case-eclipse-avatar.webp";
const BRAND_WEBP =
  "/__l5e/assets-v1/d74d0348-755b-4078-8712-b7ef6fbce18f/brand-mark.webp";

/** Eclipse Paving case-study cover (portfolio image). */
export const caseCover = {
  webpSrcSet: `${cover400Webp.url} 400w, ${cover800Webp.url} 800w`,
  fallbackSrcSet: `${cover400Jpg.url} 400w, ${cover800Jpg.url} 800w`,
  fallbackSrc: cover800Jpg.url,
  /** Card-sized cover: full width on mobile, ~400px in the desktop layout. */
  sizes: "(max-width: 767px) 100vw, 400px",
};

/** Eclipse Paving founder avatar (single small size — WebP with JPEG fallback). */
export const caseAvatar = {
  webpSrcSet: AVATAR_WEBP,
  fallbackSrc: avatar96Jpg.url,
};

/** Brand mark / logo (transparent — WebP with PNG fallback). */
export const brandMark = {
  webpSrcSet: BRAND_WEBP,
  fallbackSrc: brand160Png.url,
};
